import { useAuth } from '../context/AuthContext';
import {useEffect} from "react";
import {useAuthApi} from "../context/ApiContext.tsx";
import {useNavigate} from "react-router-dom";

//fake logout page, just to call the logout api
export const LogOut = () => {
    const { setMe } = useAuth();
    const authApi = useAuthApi();
    const navigate = useNavigate();

    const handleLogout = async (): Promise<void> => {
        try {
            await authApi.logout();
            setMe(null);
        } catch (error) {
            console.error('Logout failed:', error);
        }
    };

    useEffect(() => {
        handleLogout()
            .then(() => {
                navigate('/login');
            });
    }, []);

    return (
        <></>
    );

};